import React from "react";

/**
 * Colores base para las ilustraciones de ejercicios.
 */
const C = {
  skin: "#F4A261",
  clothes: "#0EA5E9",
  dark: "#0284C7",
  ground: "#D1D5DB",
};

/**
 * Ilustración SVG de la sentadilla (posición inicial → abajo).
 */
export const SentadillaIllustration = () => (
  <svg viewBox="0 0 340 165" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", maxWidth: 340 }}>
    <g transform="translate(40, 12)">
      <text x="30" y="8" fill="#9CA3AF" fontSize="9" fontFamily="sans-serif" fontWeight="600" textAnchor="middle">INICIO</text>
      <circle cx="30" cy="28" r="10" fill={C.skin} />
      <line x1="30" y1="38" x2="30" y2="80" stroke={C.clothes} strokeWidth="6" strokeLinecap="round" />
      <line x1="30" y1="50" x2="12" y2="68" stroke={C.skin} strokeWidth="4" strokeLinecap="round" />
      <line x1="30" y1="50" x2="48" y2="68" stroke={C.skin} strokeWidth="4" strokeLinecap="round" />
      <line x1="30" y1="80" x2="18" y2="120" stroke={C.dark} strokeWidth="5" strokeLinecap="round" />
      <line x1="30" y1="80" x2="42" y2="120" stroke={C.dark} strokeWidth="5" strokeLinecap="round" />
      <line x1="18" y1="120" x2="10" y2="120" stroke="#333" strokeWidth="3" strokeLinecap="round" />
      <line x1="42" y1="120" x2="50" y2="120" stroke="#333" strokeWidth="3" strokeLinecap="round" />
      <line x1="0" y1="125" x2="60" y2="125" stroke={C.ground} strokeWidth="1.5" strokeDasharray="4 3" />
    </g>
    <path d="M115 72 L135 72" stroke="#10B981" strokeWidth="2" markerEnd="url(#arr1)" />
    <g transform="translate(145, 12)">
      <text x="30" y="8" fill="#10B981" fontSize="9" fontFamily="sans-serif" fontWeight="600" textAnchor="middle">ABAJO</text>
      <circle cx="30" cy="40" r="10" fill={C.skin} />
      <line x1="30" y1="50" x2="30" y2="82" stroke={C.clothes} strokeWidth="6" strokeLinecap="round" />
      <line x1="30" y1="58" x2="55" y2="55" stroke={C.skin} strokeWidth="4" strokeLinecap="round" />
      <line x1="30" y1="58" x2="55" y2="62" stroke={C.skin} strokeWidth="4" strokeLinecap="round" />
      <line x1="30" y1="82" x2="12" y2="95" stroke={C.dark} strokeWidth="5" strokeLinecap="round" />
      <line x1="12" y1="95" x2="15" y2="120" stroke={C.dark} strokeWidth="5" strokeLinecap="round" />
      <line x1="30" y1="82" x2="48" y2="95" stroke={C.dark} strokeWidth="5" strokeLinecap="round" />
      <line x1="48" y1="95" x2="45" y2="120" stroke={C.dark} strokeWidth="5" strokeLinecap="round" />
      <line x1="15" y1="120" x2="7" y2="120" stroke="#333" strokeWidth="3" strokeLinecap="round" />
      <line x1="45" y1="120" x2="53" y2="120" stroke="#333" strokeWidth="3" strokeLinecap="round" />
      <line x1="0" y1="125" x2="60" y2="125" stroke={C.ground} strokeWidth="1.5" strokeDasharray="4 3" />
      <path d="M 30 82 Q 22 90 12 95" stroke="#F59E0B" strokeWidth="1.5" fill="none" strokeDasharray="3 2" />
      <text x="6" y="88" fill="#F59E0B" fontSize="8" fontWeight="600">90°</text>
    </g>
    <g transform="translate(225, 22)">
      <rect x="0" y="0" width="105" height="115" rx="10" fill="#ECFDF5" stroke="#A7F3D0" strokeWidth="1" />
      <text x="12" y="18" fill="#065F46" fontSize="9" fontWeight="700">CLAVES:</text>
      <text x="12" y="35" fill="#047857" fontSize="8">• Espalda recta</text>
      <text x="12" y="50" fill="#047857" fontSize="8">• Rodillas no pasan</text>
      <text x="12" y="63" fill="#047857" fontSize="8">  la punta del pie</text>
      <text x="12" y="80" fill="#047857" fontSize="8">• Peso en talones</text>
      <text x="12" y="95" fill="#047857" fontSize="8">• Baja hasta 90°</text>
      <text x="12" y="110" fill="#047857" fontSize="8">• Core activado</text>
    </g>
    <defs>
      <marker id="arr1" markerWidth="8" markerHeight="6" refX="8" refY="3" orient="auto">
        <path d="M0 0 L8 3 L0 6Z" fill="#10B981" />
      </marker>
    </defs>
  </svg>
);

/**
 * Ilustración SVG de la zancada.
 */
export const ZancadaIllustration = () => (
  <svg viewBox="0 0 340 165" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", maxWidth: 340 }}>
    <g transform="translate(30, 12)">
      <text x="30" y="8" fill="#9CA3AF" fontSize="9" fontFamily="sans-serif" fontWeight="600" textAnchor="middle">INICIO</text>
      <circle cx="30" cy="28" r="10" fill={C.skin} />
      <line x1="30" y1="38" x2="30" y2="80" stroke={C.clothes} strokeWidth="6" strokeLinecap="round" />
      <line x1="30" y1="52" x2="14" y2="70" stroke={C.skin} strokeWidth="4" strokeLinecap="round" />
      <line x1="30" y1="52" x2="46" y2="70" stroke={C.skin} strokeWidth="4" strokeLinecap="round" />
      <line x1="30" y1="80" x2="22" y2="120" stroke={C.dark} strokeWidth="5" strokeLinecap="round" />
      <line x1="30" y1="80" x2="38" y2="120" stroke={C.dark} strokeWidth="5" strokeLinecap="round" />
      <line x1="22" y1="120" x2="14" y2="120" stroke="#333" strokeWidth="3" strokeLinecap="round" />
      <line x1="38" y1="120" x2="46" y2="120" stroke="#333" strokeWidth="3" strokeLinecap="round" />
      <line x1="0" y1="125" x2="60" y2="125" stroke={C.ground} strokeWidth="1.5" strokeDasharray="4 3" />
    </g>
    <path d="M105 72 L125 72" stroke="#10B981" strokeWidth="2" markerEnd="url(#arr2)" />
    <g transform="translate(135, 12)">
      <text x="35" y="8" fill="#10B981" fontSize="9" fontFamily="sans-serif" fontWeight="600" textAnchor="middle">ZANCADA</text>
      <circle cx="35" cy="30" r="10" fill={C.skin} />
      <line x1="35" y1="40" x2="35" y2="82" stroke={C.clothes} strokeWidth="6" strokeLinecap="round" />
      <line x1="35" y1="52" x2="18" y2="68" stroke={C.skin} strokeWidth="4" strokeLinecap="round" />
      <line x1="35" y1="52" x2="52" y2="68" stroke={C.skin} strokeWidth="4" strokeLinecap="round" />
      <line x1="35" y1="82" x2="55" y2="100" stroke={C.dark} strokeWidth="5" strokeLinecap="round" />
      <line x1="55" y1="100" x2="55" y2="120" stroke={C.dark} strokeWidth="5" strokeLinecap="round" />
      <line x1="35" y1="82" x2="10" y2="100" stroke={C.dark} strokeWidth="5" strokeLinecap="round" />
      <line x1="10" y1="100" x2="10" y2="120" stroke={C.dark} strokeWidth="5" strokeLinecap="round" />
      <line x1="55" y1="120" x2="63" y2="120" stroke="#333" strokeWidth="3" strokeLinecap="round" />
      <circle cx="10" cy="122" r="3" fill="#333" />
      <line x1="0" y1="125" x2="70" y2="125" stroke={C.ground} strokeWidth="1.5" strokeDasharray="4 3" />
      <text x="64" y="112" fill="#F59E0B" fontSize="8" fontWeight="600">90°</text>
    </g>
    <g transform="translate(225, 22)">
      <rect x="0" y="0" width="105" height="115" rx="10" fill="#FEF3C7" stroke="#FDE68A" strokeWidth="1" />
      <text x="12" y="18" fill="#92400E" fontSize="9" fontWeight="700">CLAVES:</text>
      <text x="12" y="35" fill="#B45309" fontSize="8">• Torso erguido</text>
      <text x="12" y="50" fill="#B45309" fontSize="8">• Rodilla delantera</text>
      <text x="12" y="63" fill="#B45309" fontSize="8">  a 90 grados</text>
      <text x="12" y="80" fill="#B45309" fontSize="8">• Rodilla trasera</text>
      <text x="12" y="93" fill="#B45309" fontSize="8">  casi toca el piso</text>
      <text x="12" y="110" fill="#B45309" fontSize="8">• Paso controlado</text>
    </g>
    <defs>
      <marker id="arr2" markerWidth="8" markerHeight="6" refX="8" refY="3" orient="auto">
        <path d="M0 0 L8 3 L0 6Z" fill="#10B981" />
      </marker>
    </defs>
  </svg>
);

/**
 * Ilustración SVG de la plancha.
 */
export const PlanchaIllustration = () => (
  <svg viewBox="0 0 340 145" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", maxWidth: 340 }}>
    <g transform="translate(20, 30)">
      <text x="90" y="-10" fill="#10B981" fontSize="9" fontFamily="sans-serif" fontWeight="600" textAnchor="middle">POSICIÓN CORRECTA</text>
      <circle cx="165" cy="30" r="10" fill={C.skin} />
      <line x1="155" y1="35" x2="40" y2="55" stroke={C.clothes} strokeWidth="7" strokeLinecap="round" />
      <line x1="155" y1="38" x2="165" y2="75" stroke={C.skin} strokeWidth="4" strokeLinecap="round" />
      <line x1="145" y1="42" x2="155" y2="75" stroke={C.skin} strokeWidth="4" strokeLinecap="round" />
      <line x1="40" y1="55" x2="15" y2="75" stroke={C.dark} strokeWidth="5" strokeLinecap="round" />
      <line x1="40" y1="55" x2="25" y2="75" stroke={C.dark} strokeWidth="5" strokeLinecap="round" />
      <line x1="5" y1="80" x2="180" y2="80" stroke={C.ground} strokeWidth="1.5" strokeDasharray="4 3" />
      <text x="100" y="18" fill="#10B981" fontSize="8" fontFamily="sans-serif">← línea recta →</text>
    </g>
    <g transform="translate(220, 18)">
      <rect x="0" y="0" width="108" height="105" rx="10" fill="#D1FAE5" stroke="#6EE7B7" strokeWidth="1" />
      <text x="12" y="18" fill="#065F46" fontSize="9" fontWeight="700">CLAVES:</text>
      <text x="12" y="35" fill="#047857" fontSize="8">• Cuerpo en línea</text>
      <text x="12" y="50" fill="#047857" fontSize="8">• No subir caderas</text>
      <text x="12" y="65" fill="#047857" fontSize="8">• No hundir espalda</text>
      <text x="12" y="80" fill="#047857" fontSize="8">• Abdomen apretado</text>
      <text x="12" y="95" fill="#047857" fontSize="8">• Respirar normal</text>
    </g>
  </svg>
);

/**
 * Ilustración SVG de elevación de talones.
 */
export const ElevacionTalonesIllustration = () => (
  <svg viewBox="0 0 340 165" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", maxWidth: 340 }}>
    <g transform="translate(40, 12)">
      <text x="30" y="8" fill="#9CA3AF" fontSize="9" fontFamily="sans-serif" fontWeight="600" textAnchor="middle">ABAJO</text>
      <circle cx="30" cy="28" r="10" fill={C.skin} />
      <line x1="30" y1="38" x2="30" y2="80" stroke={C.clothes} strokeWidth="6" strokeLinecap="round" />
      <line x1="30" y1="52" x2="14" y2="64" stroke={C.skin} strokeWidth="4" strokeLinecap="round" />
      <line x1="30" y1="52" x2="46" y2="64" stroke={C.skin} strokeWidth="4" strokeLinecap="round" />
      <line x1="30" y1="80" x2="22" y2="118" stroke={C.dark} strokeWidth="5" strokeLinecap="round" />
      <line x1="30" y1="80" x2="38" y2="118" stroke={C.dark} strokeWidth="5" strokeLinecap="round" />
      <line x1="22" y1="118" x2="14" y2="118" stroke="#333" strokeWidth="4" strokeLinecap="round" />
      <line x1="38" y1="118" x2="46" y2="118" stroke="#333" strokeWidth="4" strokeLinecap="round" />
      <line x1="0" y1="123" x2="60" y2="123" stroke={C.ground} strokeWidth="1.5" strokeDasharray="4 3" />
    </g>
    <path d="M115 72 L135 72" stroke="#10B981" strokeWidth="2" markerEnd="url(#arr4)" />
    <g transform="translate(145, 5)">
      <text x="30" y="8" fill="#10B981" fontSize="9" fontFamily="sans-serif" fontWeight="600" textAnchor="middle">ARRIBA</text>
      <circle cx="30" cy="22" r="10" fill={C.skin} />
      <line x1="30" y1="32" x2="30" y2="74" stroke={C.clothes} strokeWidth="6" strokeLinecap="round" />
      <line x1="30" y1="44" x2="14" y2="56" stroke={C.skin} strokeWidth="4" strokeLinecap="round" />
      <line x1="30" y1="44" x2="46" y2="56" stroke={C.skin} strokeWidth="4" strokeLinecap="round" />
      <line x1="30" y1="74" x2="22" y2="112" stroke={C.dark} strokeWidth="5" strokeLinecap="round" />
      <line x1="30" y1="74" x2="38" y2="112" stroke={C.dark} strokeWidth="5" strokeLinecap="round" />
      <line x1="22" y1="112" x2="22" y2="118" stroke="#333" strokeWidth="4" strokeLinecap="round" />
      <line x1="38" y1="112" x2="38" y2="118" stroke="#333" strokeWidth="4" strokeLinecap="round" />
      <line x1="0" y1="123" x2="60" y2="123" stroke={C.ground} strokeWidth="1.5" strokeDasharray="4 3" />
      <text x="58" y="100" fill="#F59E0B" fontSize="8" fontWeight="600">↑ Sube</text>
    </g>
    <g transform="translate(225, 22)">
      <rect x="0" y="0" width="105" height="115" rx="10" fill="#EDE9FE" stroke="#C4B5FD" strokeWidth="1" />
      <text x="12" y="18" fill="#5B21B6" fontSize="9" fontWeight="700">CLAVES:</text>
      <text x="12" y="35" fill="#7C3AED" fontSize="8">• Sube lo más alto</text>
      <text x="12" y="50" fill="#7C3AED" fontSize="8">• Mantén 2 seg arriba</text>
      <text x="12" y="67" fill="#7C3AED" fontSize="8">• Baja lento</text>
      <text x="12" y="82" fill="#7C3AED" fontSize="8">• Piernas rectas</text>
      <text x="12" y="97" fill="#7C3AED" fontSize="8">• Control total</text>
    </g>
    <defs>
      <marker id="arr4" markerWidth="8" markerHeight="6" refX="8" refY="3" orient="auto">
        <path d="M0 0 L8 3 L0 6Z" fill="#10B981" />
      </marker>
    </defs>
  </svg>
);

/**
 * Ilustración SVG de técnica de carrera.
 */
export const RunningIllustration = () => (
  <svg viewBox="0 0 340 145" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", maxWidth: 340 }}>
    <g transform="translate(30, 15)">
      <text x="55" y="0" fill="#10B981" fontSize="9" fontFamily="sans-serif" fontWeight="600" textAnchor="middle">POSTURA AL CORRER</text>
      <circle cx="55" cy="22" r="10" fill={C.skin} />
      <line x1="55" y1="32" x2="50" y2="72" stroke={C.clothes} strokeWidth="6" strokeLinecap="round" />
      <line x1="52" y1="45" x2="35" y2="55" stroke={C.skin} strokeWidth="4" strokeLinecap="round" />
      <line x1="35" y1="55" x2="38" y2="40" stroke={C.skin} strokeWidth="4" strokeLinecap="round" />
      <line x1="52" y1="45" x2="68" y2="58" stroke={C.skin} strokeWidth="4" strokeLinecap="round" />
      <line x1="68" y1="58" x2="65" y2="72" stroke={C.skin} strokeWidth="4" strokeLinecap="round" />
      <line x1="50" y1="72" x2="72" y2="88" stroke={C.dark} strokeWidth="5" strokeLinecap="round" />
      <line x1="72" y1="88" x2="75" y2="108" stroke={C.dark} strokeWidth="5" strokeLinecap="round" />
      <line x1="50" y1="72" x2="28" y2="85" stroke={C.dark} strokeWidth="5" strokeLinecap="round" />
      <line x1="28" y1="85" x2="20" y2="100" stroke={C.dark} strokeWidth="5" strokeLinecap="round" />
      <line x1="75" y1="108" x2="82" y2="108" stroke="#333" strokeWidth="3" strokeLinecap="round" />
      <circle cx="20" cy="102" r="3" fill="#333" />
      <line x1="5" y1="113" x2="100" y2="113" stroke={C.ground} strokeWidth="1.5" strokeDasharray="4 3" />
      <line x1="5" y1="35" x2="20" y2="35" stroke="#0EA5E9" strokeWidth="1.5" opacity="0.4" />
      <line x1="0" y1="50" x2="18" y2="50" stroke="#0EA5E9" strokeWidth="1.5" opacity="0.3" />
      <line x1="3" y1="65" x2="15" y2="65" stroke="#0EA5E9" strokeWidth="1.5" opacity="0.2" />
    </g>
    <g transform="translate(150, 10)">
      <rect x="0" y="0" width="175" height="118" rx="10" fill="#E0F2FE" stroke="#7DD3FC" strokeWidth="1" />
      <text x="12" y="20" fill="#0369A1" fontSize="9" fontWeight="700">TÉCNICA DE CARRERA:</text>
      <text x="12" y="38" fill="#0284C7" fontSize="8">• Inclinación ligera hacia adelante</text>
      <text x="12" y="53" fill="#0284C7" fontSize="8">• Brazos a 90° y relajados</text>
      <text x="12" y="68" fill="#0284C7" fontSize="8">• Pisada debajo del cuerpo</text>
      <text x="12" y="83" fill="#0284C7" fontSize="8">• Hombros relajados, no tensos</text>
      <text x="12" y="98" fill="#0284C7" fontSize="8">• Inhala 2 pasos, exhala 2 pasos</text>
      <text x="12" y="113" fill="#0284C7" fontSize="8">• Mirada al frente, no al suelo</text>
    </g>
  </svg>
);

/**
 * Ilustración SVG de estiramientos principales.
 */
export const StretchingIllustration = () => (
  <svg viewBox="0 0 340 145" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", maxWidth: 340 }}>
    <g transform="translate(15, 15)">
      <text x="25" y="0" fill="#8B5CF6" fontSize="8" fontFamily="sans-serif" fontWeight="600" textAnchor="middle">CUÁDRICEPS</text>
      <circle cx="25" cy="18" r="8" fill={C.skin} />
      <line x1="25" y1="26" x2="25" y2="60" stroke={C.clothes} strokeWidth="5" strokeLinecap="round" />
      <line x1="25" y1="60" x2="25" y2="95" stroke={C.dark} strokeWidth="4" strokeLinecap="round" />
      <line x1="25" y1="60" x2="35" y2="75" stroke={C.dark} strokeWidth="4" strokeLinecap="round" />
      <line x1="35" y1="75" x2="38" y2="55" stroke={C.dark} strokeWidth="4" strokeLinecap="round" />
      <line x1="25" y1="40" x2="38" y2="55" stroke={C.skin} strokeWidth="3" strokeLinecap="round" />
      <line x1="25" y1="40" x2="10" y2="48" stroke={C.skin} strokeWidth="3" strokeLinecap="round" />
      <line x1="25" y1="95" x2="18" y2="95" stroke="#333" strokeWidth="3" strokeLinecap="round" />
      <line x1="5" y1="100" x2="50" y2="100" stroke={C.ground} strokeWidth="1" strokeDasharray="3 2" />
      <text x="25" y="115" fill="#7C3AED" fontSize="7" fontFamily="sans-serif" textAnchor="middle">30 seg/pierna</text>
    </g>
    <g transform="translate(85, 15)">
      <text x="30" y="0" fill="#8B5CF6" fontSize="8" fontFamily="sans-serif" fontWeight="600" textAnchor="middle">ISQUIOTIBIAL</text>
      <circle cx="25" cy="30" r="8" fill={C.skin} />
      <line x1="25" y1="38" x2="30" y2="65" stroke={C.clothes} strokeWidth="5" strokeLinecap="round" />
      <line x1="30" y1="65" x2="55" y2="85" stroke={C.dark} strokeWidth="4" strokeLinecap="round" />
      <line x1="30" y1="65" x2="15" y2="95" stroke={C.dark} strokeWidth="4" strokeLinecap="round" />
      <line x1="28" y1="45" x2="55" y2="78" stroke={C.skin} strokeWidth="3" strokeLinecap="round" />
      <line x1="55" y1="85" x2="60" y2="85" stroke="#333" strokeWidth="3" strokeLinecap="round" />
      <line x1="15" y1="95" x2="8" y2="95" stroke="#333" strokeWidth="3" strokeLinecap="round" />
      <line x1="0" y1="100" x2="65" y2="100" stroke={C.ground} strokeWidth="1" strokeDasharray="3 2" />
      <text x="30" y="115" fill="#7C3AED" fontSize="7" fontFamily="sans-serif" textAnchor="middle">30 seg/pierna</text>
    </g>
    <g transform="translate(170, 15)">
      <text x="30" y="0" fill="#8B5CF6" fontSize="8" fontFamily="sans-serif" fontWeight="600" textAnchor="middle">PANTORRILLA</text>
      <circle cx="35" cy="20" r="8" fill={C.skin} />
      <line x1="35" y1="28" x2="33" y2="62" stroke={C.clothes} strokeWidth="5" strokeLinecap="round" />
      <rect x="52" y="10" width="4" height="90" rx="2" fill="#D1D5DB" />
      <line x1="35" y1="40" x2="52" y2="35" stroke={C.skin} strokeWidth="3" strokeLinecap="round" />
      <line x1="33" y1="62" x2="42" y2="80" stroke={C.dark} strokeWidth="4" strokeLinecap="round" />
      <line x1="42" y1="80" x2="42" y2="95" stroke={C.dark} strokeWidth="4" strokeLinecap="round" />
      <line x1="33" y1="62" x2="12" y2="95" stroke={C.dark} strokeWidth="4" strokeLinecap="round" />
      <line x1="42" y1="95" x2="48" y2="95" stroke="#333" strokeWidth="3" strokeLinecap="round" />
      <line x1="12" y1="95" x2="5" y2="95" stroke="#333" strokeWidth="3" strokeLinecap="round" />
      <line x1="0" y1="100" x2="58" y2="100" stroke={C.ground} strokeWidth="1" strokeDasharray="3 2" />
      <text x="30" y="115" fill="#7C3AED" fontSize="7" fontFamily="sans-serif" textAnchor="middle">30 seg/pierna</text>
    </g>
    <g transform="translate(250, 20)">
      <rect x="0" y="0" width="80" height="95" rx="8" fill="#EDE9FE" stroke="#C4B5FD" strokeWidth="1" />
      <text x="10" y="16" fill="#5B21B6" fontSize="8" fontWeight="700">REGLAS:</text>
      <text x="10" y="32" fill="#7C3AED" fontSize="7.5">• Sin rebotes</text>
      <text x="10" y="47" fill="#7C3AED" fontSize="7.5">• Mantener 30s</text>
      <text x="10" y="62" fill="#7C3AED" fontSize="7.5">• Respirar</text>
      <text x="10" y="74" fill="#7C3AED" fontSize="7.5">  profundo</text>
      <text x="10" y="89" fill="#7C3AED" fontSize="7.5">• Sin dolor</text>
    </g>
  </svg>
);

/**
 * Componente router: recibe un tipo y renderiza la ilustración correspondiente.
 */
const ILLUSTRATION_MAP = {
  sentadilla: SentadillaIllustration,
  zancada: ZancadaIllustration,
  plancha: PlanchaIllustration,
  elevacion_talones: ElevacionTalonesIllustration,
  running: RunningIllustration,
  stretching: StretchingIllustration,
};

export default function ExerciseIllustration({ type }) {
  const Component = ILLUSTRATION_MAP[type];
  return Component ? <Component /> : null;
}
